import { UncontrolledTooltip } from 'reactstrap';
import { IconButton, BookmarkFilledIcon as bookmarkFilledIcon } from '@/shared/ui';
import useButtonAddEcgBookmark from './useButtonAddEcgBookmark';

/**
 * Renders the toolbar button that starts adding an ECG bookmark on the beat tab. Delegates the click to onClickAddBookmark from the hook and pairs the icon button with a tooltip naming the F shortcut.
 *
 * @returns The rendered bookmark button with its shortcut tooltip.
 */
const ButtonAddEcgBookmark = () => {
  const { onClickAddBookmark } = useButtonAddEcgBookmark();

  return (
    <>
      <IconButton
        id="bookmarkBtn"
        isFilledIconWithText
        className="add-bookmark-btn"
        iconComponent={<img src={bookmarkFilledIcon} alt="bookmark icon" />}
        onClick={onClickAddBookmark}
        iconText="Add a bookmark"
      />
      <UncontrolledTooltip
        className="custom-tooltip"
        target="bookmarkBtn"
        placement="right"
        delay={{ show: 0, hide: 0 }}
        hideArrow
      >
        <div className="beat-tooltip">
          Add a bookmark
          <span className="shortkey">F</span>
        </div>
      </UncontrolledTooltip>
    </>
  );
};

export default ButtonAddEcgBookmark;
